import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { Apollo} from 'apollo-angular';
import { ZipCodeApiService } from '../zipcode-api.service';
import { IZipCode } from '../../../models/zipcode.interface';
import { ListZipCodeQuery, ListZipCodeDetailedQuery } from '../../../graphql/queries/zipcode.query';

@Injectable({
    providedIn: 'root'
  })
export class ZipCodeGqlService implements ZipCodeApiService {

    constructor(
        private apollo: Apollo
      ) {}
   
    public get(): Observable<IZipCode[]> {
      //console.log(`ZipCodeGql.get()`);
      return this.apollo
        .watchQuery({
          query: ListZipCodeQuery
        })
        .valueChanges
        .pipe(map(result => result.data['zipCodes'] as IZipCode[]), take(1));   
    }

    public getDetailed(): Observable<IZipCode[]> {
      //console.log(`ZipCodeGql.getDetailed()`);
      return this.apollo
        .watchQuery({
          query: ListZipCodeDetailedQuery
        })
        .valueChanges
        .pipe(map(result => result.data['zipCodes'] as IZipCode[]), take(1));   
    }

}